import { combineReducers } from 'redux-immutable'
import publicHolidayListReducer from './public-holiday-list-reducer'
import publicHolidayCreateReducer from './public-holiday-create-reducer'
import publicHolidayGetReducer from './public-holiday-get-reducer'
import publicHolidayEditReducer from './public-holiday-edit-reducer'
import publicHolidayDeleteReducer from './public-holiday-delete-reducer'
import publicHolidayExportReducer from './public-holiday-export-reducer'

export default combineReducers({
  publicHolidayList: publicHolidayListReducer,
  publicHolidayCreate: publicHolidayCreateReducer,
  publicHolidayGet: publicHolidayGetReducer,
  publicHolidayEdit: publicHolidayEditReducer,
  publicHolidayDelete: publicHolidayDeleteReducer,
  publicHolidayExport: publicHolidayExportReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/public-holiday/index.js